export const JSON_SCHEMA_VERSION = 'https://json-schema.org/draft/2020-12/schema';

export const AJV_EXTENSION_REF_SCHEMA = `x-ref-schema` as const;
export const AJV_EXTENSION_PROPERTY_PATH = `x-property-path` as const;

//  Records v Objects
export const X_OBJECT_TYPE = `x-object-type` as const;
export enum XObjectType {
    RECORD = 'record',
    OBJECT = 'object',
}
